import React from 'react'
import { useMediaQuery } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import BasePage from 'src/components/layouts/BasePage'
import DocumentTitle from 'src/components/common/DocumentTitle'
import { useTrialDashboardPageStyles } from '../shared/useTrialDashboardPageStyles'
import SherwinTrialOverDashboardDesktop from './desktop/SherwinTrialOverDashboardDesktop'
import SherwinTrialOverDashboardMobile from './mobile/SherwinTrialOverDashboardMobile'

// A cancelled account never reaches here any more — DashboardComponent renders
// DeactivatedDashboard for `!isSubscribed` first (ENG-1532). Deliberately no Sherwin variant of
// the block screen: it would be a fourth dashboard for a state nobody should sit in.
export default function SherwinTrialOverDashboard() {
  const classes = useTrialDashboardPageStyles()
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  return (
    <BasePage className={classes.basePage} width="xl">
      <DocumentTitle title="Trial Expired" />
      {isMobile ? <SherwinTrialOverDashboardMobile /> : <SherwinTrialOverDashboardDesktop />}
    </BasePage>
  )
}
